export default __webpack_public_path__ + "images/dec294d39a3ecf572e96d45bb04a19d9.svg";